export default __webpack_public_path__ + "static/media/shrine.ec9c9b6c.png";